export const getLocationString = loc => {
    loc.psc = pscFormater(loc.psc)
    return loc.typ_so=="č.p." ? loc.nazev_ulice ?(loc.nazev_ulice+" "+loc.cd+ (loc.co ? "/"+loc.co:"") +", "+loc.nazev_obec+" "+loc.psc) : loc.nazev_obec+" "+loc.cd+ (loc.co ? "/"+loc.co:"") +", "+loc.psc  :  loc.nazev_obec+" č.e. "+loc.cd+" "+loc.psc
}

function pscFormater(psc) {
    return psc.replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
}
